export const MAX_PILLS = 5
export const MAX_LABEL_LENGTH = 30

const VALIDATION_ERRORS = {
  TOO_MANY_PILLS: `A maximum of ${MAX_PILLS} popular searches are allowed.`,
  MISSING_LABEL: 'Every popular search needs a label.',
  LABEL_TOO_LONG: `Popular search labels must be ${MAX_LABEL_LENGTH} characters or fewer.`,
  MISSING_URL: 'Every popular search needs a destination URL.'
}

export const validatePopularSearchPills = pills => {
  const pillList = Array.isArray(pills) ? pills : []

  if (pillList.length > MAX_PILLS) {
    return { isValid: false, message: VALIDATION_ERRORS.TOO_MANY_PILLS }
  }

  for (let index = 0; index < pillList.length; index += 1) {
    const label = (pillList[index]?.label || '').trim()
    const url = (pillList[index]?.url || '').trim()

    if (!label) {
      return { isValid: false, message: `Popular search ${index + 1}: ${VALIDATION_ERRORS.MISSING_LABEL}` }
    }

    if (label.length > MAX_LABEL_LENGTH) {
      return { isValid: false, message: `Popular search ${index + 1}: ${VALIDATION_ERRORS.LABEL_TOO_LONG}` }
    }

    if (!url) {
      return { isValid: false, message: `Popular search ${index + 1}: ${VALIDATION_ERRORS.MISSING_URL}` }
    }
  }

  return { isValid: true, message: '' }
}
